// extracted by mini-css-extract-plugin
module.exports = {"main":"BasicContentCTAButton_main__rQV1D","search-fade-in":"BasicContentCTAButton_search-fade-in__DlphE"};